import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ReminderService } from './services/reminder.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ReminderDialogComponent } from '../Dialogs/reminders/reminders.component';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TasksService } from 'src/app/pages/tasks/services/tasks.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-reminder-popup',
    templateUrl: './reminder-popup.component.html',
    standalone: false
})
export class ReminderPopupComponent implements OnInit, OnDestroy {
  reminders: any[] = [];
  currentReminder: any = null;
  subscriptions: Subscription[] = [];
  reminderInterval: any;
  
  constructor(private location: Location,private reminderService: ReminderService, public dialog: MatDialog,private _snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.getReminderListing();
    setInterval(() => {
      this.getReminderListing();
    }, 180000);

    // Call scheduleNextReminder every second
    this.reminderInterval = setInterval(() => {
      this.scheduleNextReminder();
    }, 30000);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.reminderInterval) {
      clearInterval(this.reminderInterval);
    }
  }


  private isPublicOrAuthPage(): boolean {
    const currentPath = this.location.path() || window?.location?.pathname || '';
    return (
      currentPath.startsWith('/auth') ||
      currentPath.startsWith('/auth2') ||
      currentPath.startsWith('/auth3') ||
      currentPath.includes('/auth2/onboarding') ||
      currentPath.includes('/auth2/free-trial-over') ||
      currentPath.includes('/invoice/') ||
      currentPath.includes('/payment/') ||
      currentPath.includes('/lead-form-embed/') ||
      currentPath.includes('/quote-form-embed/') ||
      currentPath.includes('/e-quote-view/') ||
      currentPath.includes('/maintenance') ||
      currentPath.includes('/downloadfile') ||
      currentPath.includes('/equote-ui')
    );
  }

  // A workspace that was just created/paid for is not usable until sign-in has created its
  // session; these flags are only present during that window.
  private isWorkspacePendingActivation(): boolean {
    return !!(localStorage.getItem('create-session') || localStorage.getItem('redirect-merchant'));
  }

  getReminderListing() {
    if (this.isPublicOrAuthPage() || this.isWorkspacePendingActivation()) {
      return;
    }
    if((localStorage.getItem('userId') || localStorage.getItem('loginUserValue')) && localStorage.getItem('merchant_id')) {
      const formattedDate = this.getCurrentFormattedDate();
      const reminderListSubs = this.reminderService.taskList({hideSpinner: true}).subscribe(reminders => {
        const remData = reminders?.reminders || {};
        const combinedReminders: any[] = [];

        if (Array.isArray(remData)) {
          combinedReminders.push(...remData.filter(item => !item.calender_show_date || item.calender_show_date <= formattedDate));
        } else if (typeof remData === 'object' && remData !== null) {
          Object.keys(remData).forEach(dateKey => {
            if (dateKey <= formattedDate) {
              const list = remData[dateKey];
              if (Array.isArray(list)) {
                combinedReminders.push(...list);
              }
            }
          });
        }

        localStorage.setItem('reminderList', JSON.stringify(combinedReminders));
        this.scheduleNextReminder();
      }, () => {
        // Background poll: a failed request must not surface as an unhandled error.
      });
      this.subscriptions.push(reminderListSubs);
    }    
  }
  

  scheduleNextReminder() {
    if (this.isPublicOrAuthPage()) {
      return;
    }
    const todayReminderData = [];    
    const todayDate = this.getCurrentFormattedDate();    
    if(localStorage.getItem('reminderList') && localStorage.getItem('reminderList') != 'undefined') {
      const reminderResult = JSON.parse(localStorage.getItem('reminderList'));
      if (reminderResult && Array.isArray(reminderResult)) {
        todayReminderData.push(...reminderResult);
      }
      let newData = [];
      if(todayReminderData && todayReminderData.length > 0) {
        for(let l = 0; l < todayReminderData.length; l++) {
          const res = todayReminderData[l];
          let reminderTime;
          let reminderTimeAllow = false;
          const now = Date.now();
          if(res.reminder_time) {
            reminderTime = new Date(res.reminder_time).getTime();         
            reminderTimeAllow = Math.abs(reminderTime - now) < 30000;
          }
          if ((reminderTimeAllow || res.past || reminderTime < now || (!res.reminder_time || res.reminder_time == "" || res.reminder_time == null)) && res.calender_show_date <= todayDate) { // within a second            
            newData.push(res);   

            let reminderResult = JSON.parse(localStorage.getItem('reminderList')) || []; 
            const indexInInput = reminderResult.findIndex(item => 
              (res?.uniqueId && item.uniqueId ? item.uniqueId === res.uniqueId : item.id === res.id)
            );
            if (indexInInput !== -1) {
              reminderResult.splice(indexInInput, 1);    
              localStorage.setItem('reminderList', JSON.stringify(reminderResult));         
            }
          }          
        }
        if(newData && newData.length > 0) {
          this._snackBar.openFromComponent(ReminderSnackbarComponent, {
            data: newData,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          }); 
        }   
      }
    }  
  }

  getDurationInMinutes(durationName: string): number {
    const match = durationName.match(/(\d+)\s*min/);
    return match ? parseInt(match[1], 10) : 0;
  }


   getCurrentFormattedDate() {
    const today = new Date();
  
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() returns month from 0 to 11
    const day = String(today.getDate()).padStart(2, '0'); // getDate() returns the day of the month
  
    return `${year}-${month}-${day}`;
  }

  closeReminder() {
    this.currentReminder = null;
  }
}



@Component({
    selector: 'reminder-snackbar',
    templateUrl: './reminders.component.html',
    styleUrls: ['./reminders.component.scss'],
    standalone: false
})
export class ReminderSnackbarComponent implements OnInit, OnDestroy {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private TasksService: TasksService,public snackBarRef: MatSnackBarRef<ReminderSnackbarComponent>) { }
  subscriptions: Subscription[] = [];
  topPopup = 0;
  ngOnInit(): void {
   
  };

  closeDialog(a, item) {
    if(a == 'c') {
      const updateTaskSubs =  this.TasksService.updateTask({id: item.id, create: item}).subscribe(res => {        
        const indexInInput = this.data.findIndex(itemData => 
          (item?.uniqueId && itemData.uniqueId ? itemData.uniqueId === item.uniqueId : itemData.id === item.id)
        );
        if (indexInInput !== -1) {
          this.data.splice(indexInInput, 1);
        }
        this.checkPendingReminders();
      });
      this.subscriptions.push(updateTaskSubs);  
    } 
    if(a == 'h') {      
      const updateTaskSubs =  this.TasksService.updateTask({id: item.id, mark_as_completed: 1, update: item}).subscribe(res => {        
        const indexInInput = this.data.findIndex(itemData => 
          (item?.uniqueId && itemData.uniqueId ? itemData.uniqueId === item.uniqueId : itemData.id === item.id)
        );
        if (indexInInput !== -1) {
          this.data.splice(indexInInput, 1);
        }
        this.checkPendingReminders();
      });
      this.subscriptions.push(updateTaskSubs);
    }
    this.topPopup++;    
  }
  checkPendingReminders() {
    if(this.data.length <= 0) {
      this.snackBarRef.dismiss();
    }
  }

  closePopup() {
    this.snackBarRef.dismiss();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());    
  }
}